import { IsArray, IsNotEmpty, IsOptional, IsString, ValidateIf } from 'class-validator';

export class UnsafeDeleteEntitiesDto {
	@IsString()
	@IsNotEmpty()
	public entityName: string;

	@IsArray()
	@IsNotEmpty()
	@ValidateIf((o: UnsafeDeleteEntitiesDto) => !o?.whereStatementRaw)
	public ids: string[];

	@IsOptional()
	public whereStatementRaw?: unknown;
}
